import { Injectable } from '@angular/core'

export interface CameraInfo {
    deviceId: string
    label: string
    kind: string
    facingMode: 'user' | 'environment' | 'left' | 'right' | undefined
}

@Injectable({
    providedIn: 'root',
})
export class CameraService {
    constructor() {}

    async getCameras(): Promise<CameraInfo[]> {
        try {
            // Request permission and list devices
            const devices = await navigator.mediaDevices.enumerateDevices()
            return devices
                .filter(device => device.kind === 'videoinput')
                .map(device => ({
                    deviceId: device.deviceId,
                    label: device.label,
                    kind: device.kind,
                    facingMode: this.determineFacingMode(device),
                }))
        } catch (error) {
            console.error('Failed to get devices:', error)
            return []
        }
    }

    private determineFacingMode(device: MediaDeviceInfo): 'user' | 'environment' | 'left' | 'right' | undefined {
        // Some browsers might support capabilities directly
        if ((device as any).getCapabilities) {
            const capabilities: any = (device as any).getCapabilities()
            if (capabilities.facingMode) {
                return capabilities.facingMode[0]
            }
        }

        // Infer from label as a fallback
        if (device.label.toLowerCase().includes('front')) {
            return 'user'
        } else if (device.label.toLowerCase().includes('back')) {
            return 'environment'
        } else if (device.label.toLowerCase().includes('rear')) {
            return 'environment'
        } else {
            return undefined // facing mode is indeterminate
        }
    }
}
